if (!customElements.get("bfcm2025-products-group")) {
    customElements.define("bfcm2025-products-group", class VideoProductsGroup extends HTMLElement {
        constructor() {
            super();
            this.tabs = this.querySelectorAll('.bfcm2025-products-group-tab-item');
            this.wrappers = this.querySelectorAll('.bfcm2025-products-group-wrapper')
        }

        connectedCallback() {
            this.initTabListener()
        }

        initTabListener() {
            this.tabs.forEach((tab) => {
                tab.addEventListener('click', this.handleTabClick.bind(this, tab))
            })
        }

        handleTabClick(clickTab) {
            const currentGroupHandle = clickTab.dataset.group;
            this.tabs.forEach((tab) => {
                tab.classList.remove('active')
                if (tab.dataset.group === currentGroupHandle) {
                    tab.classList.add('active')
                }
            })

            this.wrappers.forEach((wrapper) => {
                wrapper.classList.remove('active')
                if (wrapper.dataset.group === currentGroupHandle) {
                    wrapper.classList.add('active')
                    const swiper = wrapper.querySelector('swiper-component');
                    if (swiper) {
                        swiper.updateSlides()
                        swiper.updateAutoHeight(300)
                    }
                }
            })
        }
    })
}